<template>
  <div class="form-group">
    <label for="contact">
      {{ $t('order.clientContactPerson') }}:
    </label>

    <d-row v-if="!readOnly">
      <d-col cols="12" md="6" lg="8" class="d-flex">
        <div :class="{ 'form-control': true, 'is-select': true }">
          <v-select
            :options="customerContacts"
            :disabled="!customerId || loadingCustomerContacts"
            v-model="contact_id"
            :searchable="true"
            :clearable="true"
            :reduce="contact => contact.id"
            :placeholder="$t('ui.selectContactPerson')"
            label="name">
            <template slot="no-options">
              {{ $t('order.noContactPeople') }}
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.name }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.name }}
              </div>
            </template>
          </v-select>
        </div>

        <d-button
          v-if="selectedContact"
          theme="primary"
          outline
          class="ml-2 text-nowrap"
          @click.prevent="$bus.$emit('order-show-contact-person-view-popup')">
          {{ $t('order.showContact') }}
        </d-button>
      </d-col>

      <d-col cols="12" md="6" lg="4">
        <d-button
          @click.prevent="showContactPersonNewPopup"
          theme="primary"
          :disabled="!customerId || loadingCustomerContacts"
          outline
          block-level>
          <i class="material-icons">add</i>
          {{ $t('order.addNewContactPerson') }}
        </d-button>
      </d-col>
    </d-row>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'order-select-contact',
  props: [
    'customerId',
    'readOnly'
  ],
  data () {
    return {
      contact_id: null,
      customerContacts: [],
      loadingCustomerContacts: false,
      loadCustomerContactsError: false,
      selectedContact: null
    }
  },
  watch: {
    customerId (newValue, oldValue) {
      if (oldValue) {
        this.contact_id = null;
      }

      this.fetchContacts();
    },
    contact_id (newValue) {
      if (newValue !== 0 && newValue !== null) {
        if (this.customerContacts && this.customerContacts.length) {
          let contactData = this.customerContacts.filter(contact => contact.id === newValue);

          if (contactData[0]) {
            this.selectedContact = JSON.parse(JSON.stringify(contactData[0]));
          } else {
            this.selectedContact = null;
            this.contact_id = null;
          }
        }
      } else {
        this.selectedContact = null;
      }
    },
    customerContacts () {
      if (this.customerContacts && this.customerContacts.length) {
        let contactData = this.customerContacts.filter(contact => contact.id === this.contact_id);

        if (contactData[0]) {
          this.selectedContact = JSON.parse(JSON.stringify(contactData[0]));
        } else {
          this.selectedContact = null;
          this.contact_id = null;
        }
      }
    }
  },
  mounted () {
    this.$bus.$on('order-select-contact-fetch-data', this.fetchContacts);
    this.$bus.$on('order-select-contact-set-id', this.setContactID);
    this.fetchContacts();
  },
  methods: {
    fetchContacts (contactIdToSet = false) {
      if (!this.customerId) {
        return;
      }

      this.loadingCustomerContacts = true;

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/customers/contacts/items',
        outputKey: 'customerContacts',
        errorKey: 'loadCustomerContactsError',
        params: {
          customer_id: this.customerId
        },
        successAction: () => {
          this.loadingCustomerContacts = false;

          Vue.nextTick(() => {
            if (contactIdToSet) {
              this.contact_id = contactIdToSet;
            }
          });
        }
      });
    },
    showContactPersonNewPopup () {
      this.$bus.$emit('order-show-add-contact-person-popup');
    },
    setContactID (newID) {
      this.contact_id = newID;
    },
    getContact () {
      let selectedContact = this.customerContacts.filter(contact => contact.id === this.contact_id);

      if (selectedContact.length) {
        return selectedContact[0];
      }

      return null;
    }
  },
  beforeDestroy () {
    this.$bus.$off('order-select-contact-fetch-data', this.fetchContacts);
    this.$bus.$off('order-select-contact-set-id', this.setContactID);
  }
}
</script>
